/* tslint:disable */
/* eslint-disable */
/**
 * Web API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import type { FxIdApplicationPublicDataBuilderPlatformDataOptionsPlatformDataOptionsOdnoklassniki } from './FxIdApplicationPublicDataBuilderPlatformDataOptionsPlatformDataOptionsOdnoklassniki';
import {
    instanceOfFxIdApplicationPublicDataBuilderPlatformDataOptionsPlatformDataOptionsOdnoklassniki,
    FxIdApplicationPublicDataBuilderPlatformDataOptionsPlatformDataOptionsOdnoklassnikiFromJSON,
    FxIdApplicationPublicDataBuilderPlatformDataOptionsPlatformDataOptionsOdnoklassnikiFromJSONTyped,
    FxIdApplicationPublicDataBuilderPlatformDataOptionsPlatformDataOptionsOdnoklassnikiToJSON,
} from './FxIdApplicationPublicDataBuilderPlatformDataOptionsPlatformDataOptionsOdnoklassniki';

/**
 * @type FxIdApplicationPublicDataBuilderPlatformDataOptionsOdnoklassniki
 * 
 * @export
 */
export type FxIdApplicationPublicDataBuilderPlatformDataOptionsOdnoklassniki = FxIdApplicationPublicDataBuilderPlatformDataOptionsPlatformDataOptionsOdnoklassniki;

export function FxIdApplicationPublicDataBuilderPlatformDataOptionsOdnoklassnikiFromJSON(json: any): FxIdApplicationPublicDataBuilderPlatformDataOptionsOdnoklassniki {
    return FxIdApplicationPublicDataBuilderPlatformDataOptionsOdnoklassnikiFromJSONTyped(json, false);
}

export function FxIdApplicationPublicDataBuilderPlatformDataOptionsOdnoklassnikiFromJSONTyped(json: any, ignoreDiscriminator: boolean): FxIdApplicationPublicDataBuilderPlatformDataOptionsOdnoklassniki {
    if (json == null) {
        return json;
    }
    if (instanceOfFxIdApplicationPublicDataBuilderPlatformDataOptionsPlatformDataOptionsOdnoklassniki(json)) {
        return FxIdApplicationPublicDataBuilderPlatformDataOptionsPlatformDataOptionsOdnoklassnikiFromJSONTyped(json, true);
    }

    return {} as any;
}

export function FxIdApplicationPublicDataBuilderPlatformDataOptionsOdnoklassnikiToJSON(json: any): any {
    return FxIdApplicationPublicDataBuilderPlatformDataOptionsOdnoklassnikiToJSONTyped(json, false);
}

export function FxIdApplicationPublicDataBuilderPlatformDataOptionsOdnoklassnikiToJSONTyped(value?: FxIdApplicationPublicDataBuilderPlatformDataOptionsOdnoklassniki | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    if (instanceOfFxIdApplicationPublicDataBuilderPlatformDataOptionsPlatformDataOptionsOdnoklassniki(value)) {
        return FxIdApplicationPublicDataBuilderPlatformDataOptionsPlatformDataOptionsOdnoklassnikiToJSON(value as FxIdApplicationPublicDataBuilderPlatformDataOptionsPlatformDataOptionsOdnoklassniki);
    }

    return {};
}

